(function () {

    "use strict";
    function homeController(basicService) {

        var vm = this;
        basicService.instantiate(vm);
        vm.configHead(null);
        
    }

    homeController.$inject = ["sphforms.basicService"];

    angular.module("sphforms.main")
        .component("sphformsHome", {
            transclude: true,
            controller: homeController,
            templateUrl: "modules/main/components/home/home.template.html"
        });

}());
